module.exports = __webpack_public_path__ + "img/abou_ic1.79847c88.png";